<!-- =========================================================================================
    File Name: EmailSidebar.vue
    Description: Email Application Sidebar(Filter) (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="email__email-sidebar h-full">
    <div class="m-6 clearfix">
      <vs-button
        class="bg-primary-gradient w-full"
        icon-pack="feather"
        icon="icon-edit"
        @click="activePrompt = true"
        >Talep Oluştur</vs-button
      >
    </div>

    <!-- compose email -->
    <vs-prompt
      class="email-compose"
      title="Yeni Talep"
      accept-text="Gönder"
      cancel-text="Vazgeç"
      @cancel="clearFields"
      @accept="sendMail"
      @close="clearFields"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <component
        :is="scrollbarTag"
        class="scroll-area p-4"
        :settings="settings"
        :key="$vs.rtl"
      >
        <form @submit.prevent>
          <h1 class="text-primary">{{ activeUserInfo.crmCustomerCode }}</h1>
          <vs-input
            name="ticketTitle"
            label-placeholder="Konu"
            v-model="ticketTitle"
            class="w-full mb-1"
            v-validate="'required'"
          />
          <span class="text-danger text-sm mb-3" v-show="errors.has('ticketTitle')">{{
            errors.first("ticketTitle")
          }}</span>
          <quill-editor
            v-model="ticketDetails"
            :options="editorOption"
            v-validate="'required'"
            name="editorOption"
          />
          <span class="text-danger text-sm" v-show="errors.has('editorOption')">{{
            errors.first("editorOption")
          }}</span>
          <!--         <vs-upload
            multiple
            text="Ekler"
            :show-upload-button="false"
            class="compose-mail-attachment"
          />-->
        </form>
      </component>
    </vs-prompt>

    <component
      :is="scrollbarTag"
      class="email-filter-scroll-area"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="px-6 pb-2 flex flex-col">
        <!-- inbox -->
        <router-link
          tag="span"
          :to="`${baseUrl}/inbox`"
          class="flex justify-between items-center cursor-pointer"
          :class="{ 'text-primary': mailFilter == 'inbox' }"
        >
          <div class="flex items-center mb-2">
            <feather-icon
              icon="MailIcon"
              :svgClasses="[
                { 'text-primary stroke-current': mailFilter == 'inbox' },
                'h-6 w-6',
              ]"
            ></feather-icon>
            <span class="text-lg ml-3">Gelen</span>
          </div>
          <template v-if="emailMeta.unreadMails">
            <vs-chip
              class="number"
              color="primary"
              v-if="emailMeta.unreadMails.folder.inbox.length > 0"
              >{{ emailMeta.unreadMails.folder.inbox.length }}</vs-chip
            >
          </template>
        </router-link>

        <!-- sent -->
        <router-link
          tag="span"
          :to="`${baseUrl}/sent`"
          class="flex items-center mt-4 mb-2 cursor-pointer"
          :class="{ 'text-primary': mailFilter == 'sent' }"
        >
          <feather-icon
            icon="SendIcon"
            :svgClasses="[
              { 'text-primary stroke-current': mailFilter == 'sent' },
              'h-6 w-6',
            ]"
          ></feather-icon>
          <span class="text-lg ml-3">Gönderilen</span>
        </router-link>
      </div>
      <vs-divider></vs-divider>
    </component>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Validator } from "vee-validate";
import { uuid } from "vue-uuid";
import axios from "axios";

export default {
  props: {
    emailTags: {
      type: Array,
      required: true,
    },
    mailFilter: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activePrompt: false,
      mailTo: "",
      ticketTitle: "",
      mailCC: "",
      mailBCC: "",
      ticketDetails: "",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link", "blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }],
          ],
        },
        placeholder: "Message",
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    validateForm() {
      return !this.errors.any();
    },
    baseUrl() {
      const path = this.$route.path;
      return path.slice(0, path.lastIndexOf("/"));
    },
    emailMeta() {
      return this.$store.state.email.meta;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    clearFields() {
      this.$nextTick(() => {
        this.ticketTitle = "";
        this.ticketDetails = "";
      });
    },
    sendMail() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var crmAddress = this.$store.state.crmApi;
          var crmToken = this.$store.state.account.crmtokenId;

          console.log(crmToken);

          if (!crmToken) router.push("/");
          let item = {
            id: uuid.v4(),
            customerCode: this.activeUserInfo.crmCustomerCode,
            ticketTitle: this.ticketTitle,
            ticketDetails: this.ticketDetails,
            createUser: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          };
          console.log(item);
          return new Promise((resolve, reject) => {
            axios
              .post(crmAddress + "api/Crm/add/ticket", item, {
                headers: {
                  Authorization: `Bearer ${crmToken}`,
                  token: crmToken,
                },
              })
              .then((response) => {
                resolve(response);
              })
              .catch((err) => {
                if (err.response.status == 401) {
                  router.push("/");
                }
                resolve(err.response);
              });
          });
        } else {
          this.activePrompt = true;
          this.$vs.notify({
            text: "Alanları doldurunuz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
      this.clearFields();
    },
  },
  created() {
    const dict = {
      custom: {
        mpname: {
          required: "Gereklidir",
        },
        ticketTitle: {
          required: "Gereklidir",
        },
        editorOption: {
          required: "Gereklidir",
        },
      },
    };
    Validator.localize("en", dict);
  },
  components: {
    quillEditor,
    VuePerfectScrollbar,
  },
};
</script>
